var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('vessel-monitoring-single-bay',{attrs:{"maxRows":_vm.vesselMonitoringData.maxRow,"vesselBay":_vm.vesselHatch?.vesselBays[0],"vesselHatch":_vm.vesselHatch,"minDeckTiersNo":_vm.minDeckTiersNo,"minHoldTiersNo":_vm.minHoldTiersNo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }